import React from "react";
import Utility from "../utilities/Utility";
import BasePointModel from "../models/BasePointModel";
import { Constant } from '../const';
import UserTypeStorage from "../utilities/UserTypeStorage";
import { updateLastChange } from "../utilities";

export default class LinkView extends React.Component {
  /**
   * Normal link view, with mouse and custom event handling
   * @module LinkView
   * @param {Object} props React props
   */
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
      userType: UserTypeStorage.getUserType()
    };
    this.eventHandle = this.handleEvent.bind(this);
    this.updateUser = this.updateUserType.bind(this);
  }

  updateUserType() {
    this.setState({"userType": UserTypeStorage.getUserType()});

}

  componentDidMount() {
    document.addEventListener("ev-update-focus", this.eventHandle);
    document.addEventListener("ev-link-error", this.eventHandle);
    document.addEventListener("ev-link-select", this.eventHandle);
    document.addEventListener("ev-graph-link-ignore", this.eventHandle);
    document.addEventListener('ev-update-userType', this.updateUser);
  }

  componentWillUnmount() {
    document.removeEventListener("ev-update-focus", this.eventHandle);
    document.removeEventListener("ev-link-error", this.eventHandle);
    document.removeEventListener("ev-link-select", this.eventHandle);
    document.removeEventListener("ev-graph-link-ignore", this.eventHandle);
    document.removeEventListener('ev-update-userType', this.updateUser);
  }

  /**
   * Handle document events
   * @param {Object} event Document CustomEvent
   */
  handleEvent(event) {
    if (event.type === "ev-update-focus") {
      if (event.detail === this.props.diagramEngine.clientId) {
        document.addEventListener("ev-link-error", this.eventHandle);
        document.addEventListener("ev-link-select", this.eventHandle);
      } else {
        document.removeEventListener("ev-link-error", this.eventHandle);
        document.removeEventListener("ev-link-select", this.eventHandle);
      }
    } else if (event.type === "ev-link-error") {
      if (event.detail.self === this.props.link.getID()) {
        this.forceUpdate();
      } else if (
        this.props.link.getSourcePort() &&
        this.props.link
          .getSourcePort()
          .getParent()
          .getID() === event.detail.source
      ) {
        this.props.link.suppressBroadcast = true;
        this.props.link.checkSourceOutDegree();
        this.props.link.suppressBroadcast = false;
        this.forceUpdate();
      }
    } else if (event.type === "ev-link-select") {
      if (event.detail === this.props.link.getID()) {
        this.forceUpdate();
      }
    } else if (event.type === "ev-graph-link-ignore") {
      if (event.detail === this.props.link.getID()) {
        this.forceUpdate();
      }
    }
  }

  /**
   * Generate link terminal points SVG for dragging
   * @param {number} pointIndex Index for the point on link
   * @param {Object} extraProps
   * @returns {XML}
   */
  generatePoint(pointIndex, extraProps) {
    const hasError = this.props.link.hasError();
    const colorClass = this.getColorClass();

    return (
      <g key={"point-" + this.props.link.points[pointIndex].id}>
        <circle
          cx={this.props.link.points[pointIndex].x}
          cy={this.props.link.points[pointIndex].y}
          r={5}
          className={
            "point pointui " +
            colorClass +
            (this.props.link.points[pointIndex].isSelected()
              ? " selected"
              : "") +
            (hasError ? " error" : "")
          }
        />
        <circle
          onMouseLeave={() => {
            this.setState({ selected: false });
          }}
          onMouseEnter={() => {
            this.setState({ selected: true });
          }}
          data-id={this.props.link.points[pointIndex].id}
          data-linkid={this.props.link.id}
          cx={this.props.link.points[pointIndex].x}
          cy={this.props.link.points[pointIndex].y}
          r={15}
          opacity={0}
          className={
            "point " +
            colorClass +
            (hasError ? " error" : "")
          }
          {...extraProps}
        />
      </g>
    );
  }

  /**
   * Generate link SVG
   * @param {Object} extraProps
   * @param {number} id Link index
   * @param {Object} attachment Link attachment anchor point
   * @returns {XML}
   */
  generateLink(extraProps, id, attachment) {
    const hasError = (this.state.userType !== 'client' && this.state.userType !== 'designer') ? this.props.link.hasError() : false;
    const colorClass = this.getColorClass();
    const Bottom = (
      <path
        className={
          colorClass +
          (this.state.selected || this.props.link.isSelected()
            ? " selected"
            : "") +
          (hasError ? " error" : "") +
          (this.props.link.isIgnored ? " ignored" : "")
        }
        strokeWidth={this.props.width}
        onMouseDown={event => this.handleClick(event)}
        {...extraProps}
      />
    );

    const Top = (
      <path
        className={
          colorClass + (hasError ? " error top" : "")
        }
        strokeLinecap="round"
        onMouseLeave={() => {
          $(".link_wrapper").hide();
          this.setState({ selected: false });
        }}
        onMouseEnter={event => {
          if (this.props.link.props.config.description !== undefined&&this.props.link.props.config.description!=="") {
            $(
              ".link_wrapper"
            )[0].innerText = this.props.link.props.config.description;
            $(".link_wrapper")
              .css({
                top: event.clientY - 10,
                left: event.clientX + 30
              })
              .show();
          }

          this.setState({ selected: true });
        }}
        onMouseDown={event => this.handleClick(event)}
        data-linkid={this.props.link.getID()}
        strokeOpacity={
          this.state.selected || this.props.link.isSelected() ? 0.3 : 0
        }
        strokeWidth={14}
        {...extraProps}
      />
    );

    var Attachment = null;
    if (attachment.hasOwnProperty("t1")) {
      // Triangle attachment to show link direction; calculate rotation
      var angle = 0;
      if (attachment.t1.x === attachment.t2.x) {
        if (attachment.t1.y < attachment.t2.y) {
          angle = -90;
        } else {
          angle = 90;
        }
      } else if (attachment.t1.y === attachment.t2.y) {
        if (attachment.t1.x <= attachment.t2.x) {
          angle = 180;
        } else {
          angle = 0;
        }
      } else {
        angle =
          ((Math.atan2(
            attachment.t2.y - attachment.t1.y,
            attachment.t2.x - attachment.t1.x
          ) /
            Math.PI) *
            180 +
            180) %
          360;
        if (attachment.t1.x <= attachment.t2.x && this.previousAngle > 135) {
          // Special case; do nothing for left-to-right links
        } else {
          if (angle >= 180) {
            angle -= 360;
          } else if (angle <= -180) {
            angle += 360;
          }
        }
      }
      this.previousAngle = angle;

      Attachment = (
        <polygon
          className={
            "link-attachment " +
            colorClass +
            (hasError ? " error" : "") +
            (this.props.link.isIgnored ? " ignored" : "")
          }
          points="-6,0 6,5.5 6,-5.5"
          transform={
            "rotate(" +
            angle +
            "," +
            attachment.p.x +
            "," +
            attachment.p.y +
            ") " +
            "translate(" +
            attachment.p.x +
            "," +
            attachment.p.y +
            ")"
          }
        />
      );
    }
    return (
      <g key={"link-" + id}>
        {Bottom}
        {Attachment}
        {Top}
        {this.generateLabel(attachment.m)}
      </g>
    );
  }

  generateLabel(labelPoint) {
    const charWidth = 6.7;
    var ConditionBG = null;
    var ConditionText = null;
    if (this.props.link.hasCondition()) {
      var linkName = this.props.link.getConfig("name");
      if (!linkName) {
        linkName = this.props.link.getPrettyCondition();
      }
      if (linkName && linkName.length > 30) {
        linkName = linkName.substring(0, 29) + "…";
      } else if (!linkName) {
        linkName = "&";
      }
    } else if (this.props.link.getConfig("name")) {
      var linkName = this.props.link.getConfig("name");
      if (linkName && linkName.length > 30) {
        linkName = linkName.substring(0, 29) + "…";
      }
    }
    if (labelPoint && linkName) {
      const halfWidth = (linkName.length * charWidth) / 2;
      const halfTipWidth = halfWidth + charWidth;
      ConditionBG = (
          <polygon
              className={
                "link-condition" + (this.props.link.isIgnored ? " ignored" : "")
              }
              points={
                "-" +
                halfTipWidth +
                ",0 " +
                "-" +
                halfWidth +
                ",-15 " +
                halfWidth +
                ",-15 " +
                halfTipWidth +
                ",0 " +
                halfWidth +
                ",15 " +
                "-" +
                halfWidth +
                ",15"
              }
              transform={
                "translate(" + labelPoint.x + "," + labelPoint.y + ")"
              }
              onMouseLeave={() => {
                $(".preview_wrapper").hide();
                this.setState({ selected: false });
              }}
              onMouseEnter={() => {
                this.setState({ selected: true });
              }}
              onMouseDown={() => {
                const labelPoint = this.getLabelPoint();
                if (labelPoint) {
                  this.selectPoint(labelPoint);
                }
              }}
              onDoubleClick={event => this.setLabelPointToLink(event)}
              data-linkid={this.props.link.getID()}
          />
      );
      ConditionText = (
          <text
              x={0}
              y={0}
              transform={
                "translate(" + labelPoint.x + "," + (labelPoint.y - 5) + ")"
              }
              textAnchor={"middle"}
              className={
                "link-condition-text" +
                (this.props.link.isIgnored ? " ignored" : "")
              }
          >
            <tspan x={0} dy={8}>
              {linkName}
            </tspan>
          </text>
      );
    }
    return <g key={"label-" + this.props.link.id}>
      {ConditionBG}
      {ConditionText}
    </g>;
  }

  /**
   * Handle mouse click
   * @param {Object} event React event
   */
  handleClick(event) {
    if (
      !event.shiftKey &&
      !this.props.diagramEngine.isModelLocked(this.props.link)
    ) {
      this.forceUpdate();
      window.apm.cache
        .get(
        Constant.k.NAMESPACE_DIAGRAM_WIDGET,
        this.props.diagramEngine.clientId
        )
        .showLinkTerminals(this.props.link);
    }
  }

  /**
   * Add a new point to link
   * @param {Object} event React event
   * @param {number} index
   */
  addPointToLink(event, index) {
    if (
      !event.shiftKey &&
      !this.props.diagramEngine.isModelLocked(this.props.link) && !this.props.link.isCommonModule
    ) {
      const previousTimestamp = this.props.link.props.lastLocalChange;

      const point = new BasePointModel(
        this.props.link,
        this.props.diagramEngine.getRelativeMousePoint(event)
      );
      this.selectPoint(point);
      this.props.link.addPoint(point, index);
      updateLastChange(this.props.link.props);
       //updating request-refresh with required parameters to update link props
      window.apm.postEventToCurrentView({ 
            target: "request-refresh",
            event: {id: this.props.link.id, type: "link" , updatedLink: this.props.link}
      });

      //Change History
      const changeHistoryObject = { index: index, point: point, linkView: this, previousTimeStamp: previousTimestamp};
      window.apm.getCurrentDiagramWidget().history.saveChanges("newLinkPoint", {... changeHistoryObject});
      
    }
  }

  selectPoint(point) {
    this.props.link.points.forEach(p => {
      p.setSelected(p === point);
    });
  }

  getLabelPoint() {
    const points = this.props.link.points;
    if (points.length > 2) {
      return this.props.link.points[Math.floor(points.length / 2)];
    }
    return null;
  }

  setLabelPointToLink(event) {
    if (
        !this.props.diagramEngine.isModelLocked(this.props.link) && !this.props.link.isCommonModule
    ) {
      const labelPoint = this.getLabelPoint();

      const previousTimestamp = this.props.link.props.lastLocalChange;

      if (labelPoint) {
        
        //Change History
        const changeHistoryObject = { index: 1, point: labelPoint, linkView: this, previousTimestamp: previousTimestamp};
        
        window.apm.getCurrentDiagramWidget().history.saveChanges("removeLinkPoint", {...changeHistoryObject});

        this.props.link.removePoint(labelPoint);
        this.setState({ selected: false });
      } else {
        const point = new BasePointModel(
            this.props.link,
            this.props.diagramEngine.getRelativeMousePoint(event)
        );
        this.selectPoint(point);
        this.props.link.addPoint(point, 1);
        this.forceUpdate();

        //Change History
        const changeHistoryObject = { index: 1, point: point, linkView: this, previousTimestamp: previousTimestamp};

        window.apm.getCurrentDiagramWidget().history.saveChanges("newLinkPoint", {...changeHistoryObject});
      }
      updateLastChange(this.props.link.props);
       //updating request-refresh with required parameters to update link props
      window.apm.postEventToCurrentView({ 
            target: "request-refresh",
            event: {id: this.props.link.id, type: "link" , updatedLink: this.props.link}
      });
    }
  }

  /**
   * Remove a point from the link
   * @param {number} index
   */
  removePointFromLink(index) {
    if (
      !this.props.diagramEngine.isModelLocked(this.props.link) && !this.props.link.isCommonModule
    ) {

      //Change History
      const previousTimestamp = this.props.link.props.lastLocalChange;
      const changeHistoryObject = { index: index, point: this.props.link.getPoints()[index], linkView: this, previousTimestamp: previousTimestamp};

      window.apm.getCurrentDiagramWidget().history.saveChanges("removeLinkPoint", {... changeHistoryObject});

      //continue with point removal from selected link
      this.props.link.removePoint(this.props.link.getPoints()[index]);
      this.props.link.props.lastLocalChange = window.apm.timestamp;
      this.setState({ selected: false });
       //updating request-refresh with required parameters to update link props
      window.apm.postEventToCurrentView({ 
            target: "request-refresh",
            event: {id: this.props.link.id, type: "link" , updatedLink: this.props.link}
      });
    }
  }

  getColorClass(){
    if (this.props.link.props.config.disabledInFlow && !(window.apm.serialized.displayPrefs && window.apm.serialized.displayPrefs.hideDisabledElements)) {
      return "grey";
    } else {
      return this.props.link.props.colorClass || this.props.link.getDefaultColorClass();
    }
  }

  /**
   * React render
   * @returns {XML}
   */
  render() {
    //ensure id is present for all points on the path
    var paths = [];
    const points = this.props.link.points;
    const numPoints = points.length;
    // directional triangle
    const pPerc = 0.85;
    // approx. derivative at directional triangle
    const t1Perc = pPerc - 0.005;
    const t2Perc = pPerc + 0.005;
    // curve midpoint
    const mPerc = 0.5;
    const labelPoint = this.getLabelPoint();

    //draw the smoothed curve
    if (numPoints >= 2) {
      const segments = Utility.getCurve(this.props.link);
      const numSegs = segments.length;
      const maxIdx = numSegs - 1;
      const midIdx = Math.ceil(maxIdx / 2);

      for (var i = 0; i < segments.length; i++) {
        const seg = segments[i];
        var attachment = {};

        if (!labelPoint && i === midIdx) {
          attachment.m = Utility.getBezierCoord(
            seg[0],
            seg[1],
            seg[2],
            seg[3],
            mPerc
          );
        }
        if (i === maxIdx) {
          attachment.p = Utility.getBezierCoord(
            seg[0],
            seg[1],
            seg[2],
            seg[3],
            pPerc
          );
          attachment.t1 = Utility.getBezierCoord(
            seg[0],
            seg[1],
            seg[2],
            seg[3],
            t1Perc
          );
          attachment.t2 = Utility.getBezierCoord(
            seg[0],
            seg[1],
            seg[2],
            seg[3],
            t2Perc
          );
        }
        const nextPoint = i + 1;
        paths.push(
          this.generateLink(
            {
              "data-linkid": this.props.link.id,
              "data-point": i,
              onDoubleClick: event => {
                this.addPointToLink(event, nextPoint);
              },
              d:
                " M" +
                seg[0].x +
                " " +
                seg[0].y +
                " C " +
                seg[1].x +
                " " +
                seg[1].y +
                " " +
                seg[2].x +
                " " +
                seg[2].y +
                " " +
                seg[3].x +
                " " +
                seg[3].y
            },
            i,
            attachment
          )
        );
      }
    }

    //render label
    paths.push(this.generateLabel(labelPoint));

    //render the circles
    for (var i = 1; i < numPoints - 1; i++) {
      const thisPoint = i;
      paths.push(
        this.generatePoint(i, {
          onDoubleClick: event => {
            this.removePointFromLink(thisPoint);
          }
        })
      );
    }
    if (this.props.link.sourcePort === null) {
      paths.push(
        this.generatePoint(0, {
          onDoubleClick: event => {
            this.removePointFromLink(0);
          }
        })
      );
    }
    if (this.props.link.targetPort === null) {
      paths.push(
        this.generatePoint(numPoints - 1, {
          onDoubleClick: event => {
            this.removePointFromLink(numPoints - 1);
          }
        })
      );
    }

    if (
      this.props.link.hasError() &&
      (this.state.selected || this.props.link.isSelected()) &&
      this.state.userType !== 'client' && this.state.userType !== 'designer'
    ) {
      window.apm.postEventToCurrentView({
        target: "request-element-error-message",
        type: "show",
        context: this.props.link
      });
    } else {
      window.apm.postEventToCurrentView({
        target: "request-element-error-message",
        context: this.props.link
      });
    }

    return <g>{paths}</g>;
  }
}
